<mat-form-field class="super-search" [ngClass]="styleClass" [floatLabel]="floatLabel">
  <input
    type="text"
    matInput
    #autoComplete
    [required]="required"
    [matAutocomplete]="auto"
    placeholder="{{ 'SUPER_SEARCH_TEXT_124' | translate }}"
    (keyup)="onSearch($event)"
    [(ngModel)]="searchInput"
    name="station" />
  @if (searchInput) {
    <button matSuffix mat-icon-button type="button" class="toolbar-button" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (errorText) {
    <mat-error>{{ errorText }}</mat-error>
  }
</mat-form-field>
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayFn"
  class="super-search__autocomplete"
  (optionSelected)="selectItem($event)">
  @if (enter && searchedStations.length > 1) {
    <mat-option [value]="searchInput">
      <span class="search-option">
        @if (!searchInput) {
          <span>{{ 'SHOW_ALL_LOCATIONS' | translate }}</span>
        }
        @if (searchInput) {
          <span>
            {{ 'SHOW_ALL_LOCATIONS_VARIABLE' | translate: { searchInput: searchInput } }}
          </span>
        }
      </span>
    </mat-option>
  }
  @for (item of searchedStations; track item) {
    <mat-option [disabled]="accessComponent && !item.canSee" [value]="item">
      <span class="search-option">
        @if (item.PointName) {
          <mat-icon class="txt-gray" matTooltip="{{ 'CHARGE_POINT' | translate }}"> power </mat-icon>
          <span class="option-line">
            <span [innerHTML]="item.PointName | highlight: searchInput"></span>
            <span class="address" [innerHTML]="item.StationName | highlight: searchInput"></span>
            <span class="address" [innerHTML]="item.DeviceID | highlight: searchInput"></span>
          </span>
        } @else {
          <mat-icon class="txt-gray" matTooltip="{{ 'CHARGING_LOCATION' | translate }}"> location_on </mat-icon>
          <span class="option-line">
            <span [innerHTML]="item.Name | highlight: searchInput"></span>
            <span class="address" [innerHTML]="createAddress(item) | highlight: searchInput"></span>
          </span>
        }
      </span>
    </mat-option>
  }
</mat-autocomplete>
